import { httpService } from '@/services/HttpService';

class RegionService {
  activate(workspaceId: number, regionId: number): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/regions/${regionId}`, '');
  }
  getRegions(workspaceId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions`, {}, { isErrorSuppressed: true });
  }
}

export const regionService = new RegionService();
